import styles from "./LTwoColsLeft.module.css";

/**
 * LTwoColsLeft — page layout 2-kolumnowy: lewy sidebar + główny obszar.
 *
 * Słot `leftSidebar` zwykle ma okna typu menu/categories/filters; `main`
 * to większa kolumna z głównym contentem.
 */
export function LTwoColsLeft({ leftSidebar, main }: LTwoColsLeftProps) {
  return (
    <div className={styles.root}>
      <aside className={styles.sidebar}>{leftSidebar}</aside>
      <div className={styles.main}>{main}</div>
    </div>
  );
}

export type LTwoColsLeftProps = {
  leftSidebar: React.ReactNode;
  main: React.ReactNode;
};
